// src/main.js - Main entry point for Vite

// Load core setup and configuration first
import './auth.js';
import './setup.js';
import './constants.js';

// Load data files
import './data/pokemonDB.js';
import './data/trainerData.js';
import './data/pokeMartData.js';

// Load utilities
import './utilities.js';

// Load audio manager
import './AudioManager.js';

// Load animations (these are already modules)
import './BattleAnimation.js';
import './OverworldAnimation.js';

// Load images
import './images.js';

console.log('Game initialized through Vite!');
